import React, {
  useCallback,
  useEffect,
  // useMemo,
  useRef,
  useState,
} from 'react';
import { Container, Row } from 'reactstrap';
import { Formik, FormikProps } from 'formik';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { validationSchema } from './ValidationSchema';
// import { initialValues } from './InitialValues';
import { useDispatch, useSelector } from 'react-redux';
import { ThunkDispatch } from 'redux-thunk';
import { Action } from 'redux';
// import {
//   apiError,
//   apiSuccess,
//   setIsEdit,
//   setModalBackdrop,
// } from 'slices/productAddOn/reducer';
import { RootState } from 'slices';
// import { mapPromoAPIToPromoForm } from 'utils/mappers/promoMapper';
import AlertWrapper from './AlertWrapper';
import BreadCrumb2 from 'Components/pos2u/BreadCrumb2';
import FormActionButtons from './FormActionButtons';
// import {
//   getPromotionByID,
//   postAddPromotion,
//   putUpdatePromotion,
// } from 'services/promotionService';
import ModalBackdropNotFound from 'Components/pos2u/ModalBackdropNotFound';
import 'styles/common/checked-input-style.css';
import {
  ProductOptionFormType,
  ProductOptionValueForm,
} from 'types/product/productOptionTypes';
import {
  apiError,
  apiSuccess,
  resetProductOption,
  setIsEdit,
  setModalBackdrop,
  setProductOptionValues,
  setTotalProductOptions,
} from 'slices/productOption/reducer';
import ProductOptionForm from 'pages/ProductOptions/ProductOptionManagement/ProductOptionForm';
import {
  getCheckTotalProductOptions,
  getProductOptionByID,
  postAddProductOption,
  putUpdateProductOption,
} from 'services/ProductOptionService';
import {
  transformProductOptionAPIToForm,
  transformProductOptionFormToAPI,
} from 'utils/productOption/converter';
import SuccessModal from 'Components/pos2u/Modals/SuccessModal';
import { PRODUCT_OPTION } from 'Routes/constants';
import { PRODUCT_OPTIOINS_LIMIT } from '../ProductOptionConstants';

const ProductOptionManagementPage = () => {
  const { t, i18n } = useTranslation();

  const { id } = useParams();

  const addTitle = t('Add Product Option') + ' | POS2U';
  const editTitle = t('Edit Product Option') + ' | POS2U';
  document.title = id ? editTitle : addTitle;

  const dispatch: ThunkDispatch<RootState, void, Action> = useDispatch();
  // const history = useNavigate();

  const ProductOptionState = useSelector(
    (state: RootState) => state.ProductOption
  );
  const {
    isEdit,
    countSubmit,
    error,
    modalBackdrop,
    NameExists,
    FormErrorCount,
    ProductOptionValues,
    TotalProductOptions,
  } = ProductOptionState;

  const alertRef = useRef<HTMLDivElement | null>(null);
  const formikRef = useRef<FormikProps<ProductOptionFormType>>(null);

  // const [editData, setEditData] = useState<ProductOptionFormType | null>(null);
  const [isNotFound, setIsNotFound] = useState(false);
  const [reqDeleteSubOpt, setReqDeleteSubOpt] = useState<
    ProductOptionValueForm[]
  >([]);

  const handleDeleteOption = useCallback((option: ProductOptionValueForm) => {
    setReqDeleteSubOpt((prev) => [...prev, option]);
  }, []);

  // const setErrorMsg = useCallback(
  //   (msg: string) => {
  //     dispatch(setError(msg));
  //   },
  //   [dispatch]
  // );
  const fetchCheckTotalProductOptions = useCallback(async () => {
    try {
      const rs = await getCheckTotalProductOptions();
      if (rs.message === 'OK' && rs.error_code === 0) {
        return rs.data;
      } else {
        return null;
      }
    } catch (error) {
      console.error('Failed to get Total Product Options:', error);
      return null;
    }
  }, []);

  const isFetched = useRef(false);

  const loadProductOption = useCallback(async () => {
    if (!id || id === '') return;

    dispatch(setIsEdit(true));

    if (isFetched.current) return;

    isFetched.current = true;

    const controller = new AbortController();
    const signal = controller.signal;
    try {
      const productOpt = await getProductOptionByID(id);
      if (productOpt) {
        const transformedEditData = transformProductOptionAPIToForm(productOpt);
        // setEditData(transformedEditData);
        dispatch(setProductOptionValues(transformedEditData));
      } else {
        setIsNotFound(true);
      }
    } catch (error) {
      if (!signal.aborted) {
        console.error('Failed to load product Option data:', error);
      } else {
        console.log('Request aborted');
      }
    } finally {
      isFetched.current = false;
    }
    return () => controller.abort();
  }, [dispatch, id]);

  useEffect(() => {
    loadProductOption();
  }, [loadProductOption]);

  useEffect(() => {
    if (formikRef.current && formikRef.current.errors) {
      const errorKeys = Object.keys(formikRef.current.errors);
      if (errorKeys.length > 0) {
        const firstErrorField = document.querySelector(
          `[name="${errorKeys[0]}"]`
        ) as HTMLInputElement | null;
        if (firstErrorField) firstErrorField.focus();
      }
    }
  }, [formikRef, countSubmit]);

  useEffect(() => {
    if (formikRef.current) {
      formikRef.current.validateForm();
    }
  }, [i18n.language]);

  useEffect(() => {
    if (error !== '') {
      alertRef.current?.focus();
    }
  }, [error]);

  const toggleModalBackDrop = useCallback(() => {
    dispatch(setModalBackdrop(!modalBackdrop));
  }, [dispatch, modalBackdrop]);

  const submitProductOptionForm = async (
    values: ProductOptionFormType
    // resetForm: () => void
  ) => {
    const transformedData = transformProductOptionFormToAPI(
      values,
      reqDeleteSubOpt
    );

    try {
      if (isEdit === true && id && id !== '') {
        const updateReq = {
          id: parseInt(id, 10),
          ...transformedData,
        };
        const response = await putUpdateProductOption(updateReq);

        if (response) {
          const { message, error_code } = response;
          if (message === 'OK' && error_code === 0) {
            const { message } = response.data;
            dispatch(apiSuccess({ message }));
          } else {
            dispatch(apiError({ message }));
          }
        } else {
          dispatch(
            apiError({
              message: 'Unexpected error occurred. Please try again.',
            })
          );
        }
      } else {
        const createReq = {
          ...transformedData,
          options: transformedData.new_options ?? [],
        };
        const response = await postAddProductOption(createReq);
        if (response) {
          const { message, error_code } = response;
          if (message === 'OK' && error_code === 0) {
            const { message } = response.data;
            dispatch(apiSuccess({ message }));
          } else {
            dispatch(apiError({ message }));
          }
        } else {
          dispatch(
            apiError({
              message: 'Unexpected error occurred. Please try again.',
            })
          );
        }
      }

      // dispatch(resetProduct());

      // resetForm();
      // window.location.reload();
    } catch (error) {
      dispatch(apiError({ message: error }));
      console.error('Error updating product details:', error);
    }
  };

  return (
    <React.Fragment>
      <div className={`page-content`}>
        <Container fluid>
          {error !== '' && (
            <div
              ref={alertRef}
              tabIndex={-1}
              aria-live="assertive"
              className="mb-3"
            >
              <AlertWrapper
                type="error"
                message={error}
                heading={t('something_went_wrong')}
              />
            </div>
          )}
          <ModalBackdropNotFound
            isNotFound={isNotFound}
            setIsNotFound={setIsNotFound}
            message={`${t('Not found for Product Option ID')} ${id}`}
            redirect="/product-option"
            ButtonMsg={t('Back to Product Option')}
            icon="bx bx-arrow-back"
          />
          {/* <ModalBackdrop
            dispatch={dispatch}
            formikRef={formikRef}
            toggleModalBackDrop={toggleModalBackDrop}
          /> */}

          <SuccessModal
            isOpen={modalBackdrop}
            onClose={toggleModalBackDrop}
            goBackTo={PRODUCT_OPTION.LIST}
            addAnotherTo={PRODUCT_OPTION.ADD}
            onGoBack={() => {
              dispatch(resetProductOption());
              dispatch(setModalBackdrop(false));
            }}
            onAddAnother={() => {
              dispatch(resetProductOption());
              dispatch(setModalBackdrop(false));
              const emptyForm: ProductOptionFormType = {
                name: '',
                optionType: '1',
                forceType: '1',
                options: [{ name: '', additionalPrice: '0.00' }],
              };
              formikRef.current?.resetForm({ values: emptyForm });
            }}
          />
          <BreadCrumb2
            title={id ? t('Edit Product Option') : t('Add Product Option')}
            // title={t('Add_Promotion')}
            pageTitle={t('Product Option')}
            linkId="product-option-link"
            link="/product-option"
          />
          <Formik<ProductOptionFormType>
            // initialValues={
            //   isEdit ? initialValues(editData) : initialValues(null)
            // }
            initialValues={ProductOptionValues}
            validationSchema={validationSchema(t)}
            onSubmit={async (
              values: ProductOptionFormType
              // { resetForm }: FormikHelpers<ProductFormDetailsInterface>
            ) => {
              const rs = await fetchCheckTotalProductOptions();
              const total = Number(rs?.total ?? 0);

              if (total <= PRODUCT_OPTIOINS_LIMIT && isEdit) {
                // console.log(isEdit ? 'submit edit' : 'submit add');
                await submitProductOptionForm(values);
              } else if (total < PRODUCT_OPTIOINS_LIMIT && !isEdit) {
                //   console.log('submit add');
                await submitProductOptionForm(values);
              } else {
                console.warn('Reach limit: cannot add more options');
              }
              // if (total <= PRODUCT_OPTIOINS_LIMIT && isEdit) {
              //   console.log('submit edit');
              //   await submitProductOptionForm(values);
              // } else if (total < PRODUCT_OPTIOINS_LIMIT && !isEdit) {
              //   console.log('submit add');
              //   await submitProductOptionForm(values);
              // }
              // console.log('total options', rs?.total);
              // console.log('isEdit', isEdit);
              // console.log('PRODUCT_OPTIOINS_LIMIT', PRODUCT_OPTIOINS_LIMIT);
              dispatch(setTotalProductOptions(total));

              // return false;
              // await submitProductForm(values);
            }}
            enableReinitialize={true}
            innerRef={formikRef}
          >
            {(formik) => (
              <form
                noValidate
                className=""
                // onSubmit={(e) => {
                //   e.preventDefault();
                //   formik.handleSubmit();
                // }}
                onSubmit={formik.handleSubmit}
                // onSubmit={async (e) => {
                //   e.preventDefault();
                //   formik.handleSubmit();
                // }}
              >
                <Row>
                  <ProductOptionForm
                    formik={formik}
                    handleDeleteOption={handleDeleteOption}
                  />
                </Row>
                <FormActionButtons
                  dispatch={dispatch}
                  formik={formik}
                  NameExists={NameExists}
                  FormErrorCount={FormErrorCount}
                  reachCreateLimit={
                    TotalProductOptions >= PRODUCT_OPTIOINS_LIMIT && !isEdit
                  }
                />
              </form>
            )}
          </Formik>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default ProductOptionManagementPage;
